// @flow
export { default } from './MainMobileFooter';



// WEBPACK FOOTER //
// ./src/components/main/MainMobileFooter/index.js